import { getCompaniesId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const COMPANY_DETAIL = "COMPANY_DETAIL";

export function useCompanyDetailQuery(companyId?: number) {
	return useQuery({
		queryKey: [COMPANY_DETAIL, companyId],
		queryFn: processResponse(() => getCompaniesId(companyId!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!companyId,
	});
}
